import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'app-ecourse',
  templateUrl: './ecourse.component.html',
  styleUrls: ['./ecourse.component.css']
})
export class EcourseComponent implements OnInit {
   src_url : string;
  constructor() { }

  ngOnInit() {
    $(".header_active").removeClass("header_active")
    $(".intro-ecourse").addClass("header_active")
    if (window.location.href.indexOf("/fr/") > -1) {
      this.src_url="https://lc.unu.edu/courses/course-v1:UNU-INWEH+INWEH-13+2019/about";}
  else if (window.location.href.indexOf("/es/") > -1){
    this.src_url="https://lc.unu.edu/courses/course-v1:UNU-INWEH+INWEH-14+2020/about";}
    else if (window.location.href.indexOf("/pt/") > -1){
      this.src_url="https://lc.unu.edu/courses/course-v1:UNU-INWEH+INWEH-03+2019/about";}
      else if (window.location.href.indexOf("/ko/") > -1){
        this.src_url="https://lc.unu.edu/courses/course-v1:UNU-INWEH+INWEH-03+2019/about";}
        else if(window.location.href.indexOf("/ar/")>-1){
          this.src_url="https://lc.unu.edu/courses/course-v1:UNU-INWEH+INWEH-03+2019/about";

        }
  else {
    this.src_url="https://lc.unu.edu/courses/course-v1:UNU-INWEH+INWEH-03+2019/about";}

  }

}



// WEBPACK FOOTER //
// ./src/app/introduction/ecourse/ecourse.component.ts